__turbopack_context__.v({
  "blikInputContainer": "ihYyAq_blikInputContainer",
  "buttonContainer": "ihYyAq_buttonContainer",
});
